import React from "react";
import "./styles/About.css";
import CallToAction from "./CallToAction";
import ScrollToTopOnMount from "./utilities/ScrollToTopOnMount";
import CardDiploma from "./Layout/About/CardDiploma";

import Zoom from "react-reveal/Zoom";
import Fade from "react-reveal/Fade";
import Slide from "react-reveal/Slide";
import img1 from "../images/cto.svg";
const About = ({ img2 }) => {
  return (
    <>
      <ScrollToTopOnMount />
      <div className="about-images">
        <img className="about-image" src={img1} alt="" />
      </div>
      <div className=" about-hero">
        <p className="display-1">
          Cuando no estoy tratando de aprender algo nuevo de desarrolo web me
          encanta leer o mejorar mis habilidades en los{" "}
          <span className="resaltar">idiomas</span>
        </p>
      </div>
      <div className="about-about reveal">
        <p className="parrafo">
          Hola, gracias por leer esto. Mi nombre es Isaías Chávez, soy
          estudiante de la carrera de Ingeniería en computación en la{" "}
          <span className="resaltar">
            {" "}
            Universidad Tecnológica de la Mixteca
          </span>
        </p>
        <p className="parrafo">
          actualmente me encuentro cursando el 5 semestre. Desde que tenía 17 me
          ha apasionado el mundo del desarrollo web y he estado muy al pendiente
          de todo tipo de tecnologías que han estado surgiendo desde entonces.
        </p>
        <p className="parrafo">
          Todo lo que se hasta ahora lo he aprendido de forma autodidacta por
          medio de cursos, gran parte de ellos pagados ya que tuve la fortuna de
          poder adquirir una suscripción a una plataforma de cursos. También he
          tomado en Udemy y uno que otro en youtube.
        </p>
        <p className="parrafo">
          Me encanta aprender y me encanta el diseño. Por eso me he enfocado en
          la parte <span className="resaltar"> Fron-end </span>
          pero también estoy rellenando huecos en lo backend. Si alguien me da
          la oportunidad de trabajar de forma profesional me encantaría poder
          hacerlo. Mis redes son{" "}
          <span className="resaltar">
            {" "}
            <a href="https://www.facebook.com/profile.php?id=100002466696106">
              Facebook{" "}
            </a>{" "}
          </span>
          <span className="resaltar">
            {" "}
            <a href="#!">Twitter </a>{" "}
          </span>{" "}
          o los códigos de mis proyectos se encuentran en
          <span className="resaltar">
            {" "}
            <a href="https://github.com/isaiasChavez">Github </a>{" "}
          </span>
        </p>
      </div>
      <div className="about-talleres">
        <div>
          <h3 className="display-3 uppercase">
            Cursos y talleres que he tomado
          </h3>
          <p>
            <a href="#!" className="link">
              Link a LinkedIn para ver las diplomas
            </a>
          </p>
          <p>
            <a href="#!" className="link">
              Link hacia Platzi para ver las diplomas
            </a>
          </p>
        </div>
        <div className="about-listado">
          <Zoom>
            <CardDiploma titulo={"Curso de Bootstrap"} plataforma={"Platzi"} />
            <CardDiploma titulo={"Curso de CSS GRID"} plataforma={"Platzi"} />

            <CardDiploma
              titulo={
                " Curso de Implementación de código JQuery en Java Script"
              }
              plataforma={"Platzi"}
            />
            <CardDiploma
              titulo={"Curso de Java Standard Edition"}
              plataforma={"Platzi"}
            />
            <CardDiploma
              titulo={"Curso Fundamentos de Java Script"}
              plataforma={"Platzi"}
            />
            <CardDiploma
              titulo={"Curso de Diseño responsivo de Paginas Web"}
              plataforma={"Platzi"}
            />
            <CardDiploma
              titulo={"Curso de Java Standard Edition"}
              plataforma={"Platzi"}
            />
            <CardDiploma
              titulo={"Curso de ECMAScript 6+"}
              plataforma={"Platzi"}
            />
            <CardDiploma titulo={"Curso de React JS"} plataforma={"Platzi"} />
            <CardDiploma
              titulo={"Curso profesional de Git y GitHub 2017"}
              plataforma={"Platzi"}
            />
          </Zoom>
        </div>
        <div className="about-me">
          <div>
            <h3 className="display-2">
              Competencias y conocimientos generales
            </h3>
          </div>
          <ul className="about-listado">
            <li className="soft-skill">
              <span>
                {" "}
                <b> Proactivo: </b>
              </span>
              <p className="parrafo">
                Soy una persona altamente eficiente, si necesito aprender algo
                que me falta tomo la responsabilidad de aprenderlo por mi
                cuenta, me gusta cumplir con mis objetivos.
              </p>
            </li>
            <li className="soft-skill">
              <span>
                <b> Social: </b>
              </span>
              <p className="parrafo">
                Me encanta socializar y relacionarme con las personas que me
                rodean, soy muy comunicativo y se trabajar en equipo. Escucho a
                los que saben más que yo y me dejo enseñar.
              </p>
            </li>
            <li className="soft-skill">
              <span>
                <b> Responsable y Puntual: </b>
              </span>
              <p className="parrafo">
                Desde siempre he sido un buen estudiante, nunca en mi vida he
                tenido problemas en lo academico y es porque soy de las personas
                que consideran que haciendo las cosas con tiempo y haciendo el
                esfuerzo necesario y un poco más las cosas se solucionan.
              </p>
            </li>
          </ul>
        </div>
      </div>

      <div className="about-sitio">
        <h3 className="display-2">Sobre este sitio</h3>
        <Slide left>
          <p className="parrafo">
            Este sitio ha sido construido para tratar de demostrar mis
            conocimientos en las diversas areas del desarrollo web. Por el
            momento puedo considerar que domino o tengo una idea bastante clara
            de las siguientes tecnologias
          </p>
          <ul className="list">
            <li className="list-item">CSS</li>
            <li className="list-item">HTML</li>
            <li className="list-item">Java Script</li>
            <li className="list-item">React Js</li>
            <li className="list-item">Ecmascript 6/10</li>
            <li className="list-item">Grid sistem de CSS</li>
            <li className="list-item">Java</li>
            <li className="list-item">Bases de datos PostgreSQL</li>
            <li className="list-item">Bootstrap</li>
          </ul>
          <h3 className="display-3">
            {" "}
            En particular este sitio fue realizado con
          </h3>
          <ul className="list">
            <li className="list-item">CSS</li>
            <li className="list-item">HTML</li>
            <li className="list-item">Java Script</li>
            <li className="list-item">React Js</li>
            <li className="list-item">Grid sistem de CSS</li>
            <li className="list-item">Styled Components</li>
          </ul>
        </Slide>
      </div>
      <CallToAction />
    </>
  );
};

export default About;
